import grid from './grid'
import Isotope from 'isotope-layout';
import analytics from '../analytics'
import Cookies from 'universal-cookie';
const cookies = new Cookies();
import { TweenMax, TimelineMax, Power4 } from 'gsap'

export default (function() {

var isotopeInstance
var filterElements = []

function filterHandler(e) {
  e.preventDefault();
  let filter = e.currentTarget.dataset.filterSelector
  updateFilterState({ filter: filter }, { updateHistoryState: true })
}

function updateFilterState(state, {
  updateHistoryState = false,
} = {}) {

  const gridElement = document.querySelector('.work-container')
  const categories = document.querySelector('.filter-categories')
  const categoryFilters = Array.from(document.querySelectorAll('.work-filter'))
  var iso = Isotope.data(gridElement)
  var isoOptions = { filter: null }

  // Default the grid to show all featured works if there isn't a filter set
  if (!state.filter || state.filter === null) {
    state.filter = 'featured'
  }

  if (categories) {

    let uri = ''
    let filterSelector = ''
    if(!state.fitler && state.filter != 'featured') {
      uri = state.filter
      filterSelector = `.${state.filter.replace('.', '')}`
      isoOptions.filter = filterSelector
    }

    // Deselect any of the current active nav items
    let currentActive = categories.querySelector('.active')
    if (currentActive) {
      currentActive.classList.remove('active', 'remove-bg')
    }

    // Set the currently active nav item
    let filterElement = categories.querySelector(`[data-filter-selector="${ state.filter.replace('.', '') }"]`)
    if (filterElement) {
      filterElement.parentNode.classList.add('active')
      filterElement.parentNode.classList.remove('remove-bg')
    }

    // Update the browser history if needed
    if (updateHistoryState) {
      try {
        cookies.set('work-filter', state.filter.replace('.', ''), { path: '/' })
        window.history.pushState({ handler: 'work', filter: uri }, "Work", `/work/${uri}`)
        analytics.trackVirtualPageview({ eventCategory: `/work/${uri}` });
      } catch(e){}
    }
  }

  // Initialize the grid
  if (typeof iso === 'undefined') {

    grid.init(isoOptions)
    iso = Isotope.data(gridElement)
    isotopeInstance = iso

    cookies.set('work-filter', state.filter.replace('.', ''), { path: '/' })
    cookies.set('work-grid-sort', Object.keys(caseStudies), { path: '/' })
  } else {

    if (updateHistoryState) {

      TweenMax.to(
        gridElement, .2, {
          opacity: 0,
          onComplete: function() {

            setTimeout(function() {

              iso.shuffle();

              setTimeout(() => {
                iso.once('arrangeComplete', function(filteredItems) {

                  let filteredElements = Array.from(filteredItems).map((item) => item.element)
                  cookies.set('work-grid-sort', filteredElements.map((elem) => elem.dataset.index), { path: '/' })

                  // Set each work item to 1
                  // let workItems = Array.from(gridElement.querySelectorAll('.individual-work'))
                  TweenMax.to(filteredElements, 0, { opacity: 0, y: 50 })

                  // Make the container visible again so each item can transition in
                  TweenMax.to(gridElement, 0, {
                    opacity: 1,
                    onComplete: function() {
                      let timeline = new TimelineMax()
                      filteredElements.forEach((workItem) => {
                        timeline.add(TweenMax.to(workItem, .5, { opacity: 1, y: 0 }, { ease: Power4.easeOut }), '-=.3')
                      })
                    }
                  })
                })

                iso.arrange(isoOptions)
              }, 150)

            }, 150)
          }
        }
      )
    } else {
      iso.arrange(isoOptions)
    }
  }
}

return {
  init: function() {

    if (!document.querySelector('.work-container')) {
      return;
    }

    let categories = document.querySelector('.filter-categories')
    let categoryFilters = Array.from(document.querySelectorAll('.work-filter'))
    let timeout = null
    categoryFilters.forEach((categoryFilter) => {
      categoryFilter.addEventListener('mouseover', (e) => {
        clearTimeout(timeout)

        // Don't remove the bg when hovering on the current active item
        if (e.currentTarget.classList.contains('active')) {
          return;
        }
        let activeFilter = categories.querySelector('.active')
        activeFilter.classList.add('remove-bg')
      })

      categoryFilter.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          let activeFilter = categories.querySelector('.active')
          activeFilter.classList.remove('remove-bg')
        }, 250)
      })
    })

    if (isotopeInstance) {
      filterElements.forEach((filterElement) => {
        filterElement.removeEventListener('click', filterHandler)
      })
    }

    var workFilterSelector = undefined;
    if (typeof workFilter !== 'undefined' && workFilter) {
      workFilterSelector = `.${workFilter}`
    }

    var gridOptions = {}
    if (typeof workFilterSelector !== 'undefined') {
      gridOptions.filter = workFilterSelector
    }

    updateFilterState(gridOptions, { updateHistoryState: false })

    filterElements = Array.from(document.querySelectorAll('[data-filter-selector]'))
    filterElements.forEach((filterElement) => {
      filterElement.addEventListener('click', filterHandler)
    })


    window.addEventListener('popstate', function(e) {
      if (e.state && e.state.handler == 'work') {
        updateFilterState(e.state, { updateHistoryState: false })
      }
    })

  }
}

})();
